import React, { useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import ActiveVouchers from "./ActiveVouchers";
import RedeemedVouchers from "./RedeemedVouchers";
import { useState } from "react";
import { VouchersApi } from "../../Utils/Api/VouchersApi";
import Loader from "../../Components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";

const MyVouchers = (props) => {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const Handler = async () => {
    setLoading(true);
    const activeData = await VouchersApi(() => {
      navigate("/");
    });
    setLoading(false);
    setVouchers(activeData.vouchers_list);
  };
  useEffect(() => {
    Handler();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Vouchers</p>
          <Tabs
            defaultActiveKey="active"
            id="uncontrolled-tab-example"
            className="mb-3 vou-tab mt-3"
          >
            <Tab eventKey="active" title="Active vouchers">
              <ActiveVouchers vouchers={vouchers} />
            </Tab>
            <Tab eventKey="redeemed" title="Redeemed vouchers">
              <RedeemedVouchers vouchers={vouchers} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default MyVouchers;
